import styled from "styled-components";

export const TourStepContainer = styled.div`
  p + p {
    margin-top: 1em;
  }
`;
